/* @flow */

import type { ThemeFunction } from 'src/shared/app/base/types/themeTypes';

export default {
  'div.MuiAlert-message a': {
    color: 'currentColor',
  },
  'div.MuiAlert-standardSuccess': {
    backgroundColor: ({ theme }: ThemeFunction) =>
      theme.alertSuccessBackgroundColor,
    color: ({ theme }: ThemeFunction) => theme.alertSuccessFontColor,
  },
  'div.MuiAlert-standardError': {
    backgroundColor: ({ theme }: ThemeFunction) =>
      theme.alertErrorBackgroundColor,
    color: ({ theme }: ThemeFunction) => theme.alertErrorFontColor,
  },
  'div.MuiAlert-standardWarning': {
    backgroundColor: ({ theme }: ThemeFunction) =>
      theme.alertWarningBackgroundColor,
    color: ({ theme }: ThemeFunction) => theme.alertWarningFontColor,
  },
  'div.MuiOutlinedInput-input': {
    padding: [10, 14],
  },
  'div.MuiOutlinedInput-input:focus': {
    borderRadius: 8,
  },
  'div.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
    borderColor: ({ theme }: ThemeFunction) => theme.accentColor,
    borderWidth: 1,
    overflow: 'hidden',
  },
};
